import React from 'react'
import { H2 } from '../Heading/index'
import TrustPilot from '../TrustPilot/index'

/**
 * Renders a testimonials section including titles and a TrustPilot widget.
 *
 * @param {Map} staticText - Text strings used for subtitles and titles
 * @returns {JSX.Element} Testimonials block with TrustPilot reviews
 */
function SharePageTestimonials (props) {
  const { staticText } = props

  return (
    <div className="share-page__testimonials">
      <div className="share-page__subtitle share-page__testimonials-subtitle">{staticText.get('testimonialsSubtitle')}</div>
      <H2 className="share-page__title share-page__testimonials-title">{staticText.get('testimonialsTitle')}</H2>
      <div className="share-page__testimonials-trustpilot">
        <TrustPilot
          templateId="539ad60defb9600b94d7df2c"
          templateHeight="500px"
          renderFr={true}
        />
      </div>
    </div>
  )
}

export default SharePageTestimonials
